import { ADMIN_ALERTS_CHANGED, api, ApiError } from '../../lib/api/client.js';

export { ADMIN_ALERTS_CHANGED };

export function announceAdminAlertsChanged(): void {
  window.dispatchEvent(new Event(ADMIN_ALERTS_CHANGED));
}

/**
 * The two refusals an administrator's write can meet that are not about the
 * content of the request, and the sentence each one deserves:
 *
 *  - `reauth` — the act needs a Google sign-in from the last few minutes
 *    (`428 reauth_required`), and the answer is to sign in again;
 *  - `frozen` — this administrator's writes are stopped by the brake or a
 *    lockdown (`423 admin_frozen`), and only somebody else can lift it.
 */
export type AdminWriteRefusal = 'reauth' | 'frozen' | 'other';

export function adminWriteRefusal(error: unknown): AdminWriteRefusal {
  if (!(error instanceof ApiError)) return 'other';
  if (error.status === 428 || error.code === 'reauth_required') return 'reauth';
  if (error.status === 423 || error.code === 'admin_frozen') return 'frozen';
  return 'other';
}

export const REAUTH_MESSAGE =
  'Por segurança, esta ação pede uma entrada recente. Entre de novo com o Google e confirme outra vez.';

export const FROZEN_MESSAGE =
  'Suas alterações estão congeladas. Outro administrador pode liberá-las em Usuários.';

/**
 * Sends the browser through Google and back to this same address, where the
 * person repeats the act with a session that is now fresh. Rejects when the
 * sign-in could not be started, so the caller can say so.
 */
export async function signInAgain(): Promise<void> {
  const { url } = await api.signInWithGoogle(window.location.href);
  window.location.href = url;
}
